var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "check_svg__svg-icon",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "check_svg__check"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9 16.17 5.53 12.7a.996.996 0 1 0-1.41 1.41l4.18 4.18c.39.39 1.02.39 1.41 0L20.29 7.71a.996.996 0 1 0-1.41-1.41z",
    className: "check_svg__vector"
  }))));
};
export { SvgCheck as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9Im5vbmUiIHZpZXdCb3g9IjAgMCAyNCAyNCIgY2xhc3M9InN2Zy1pY29uIj48ZyBjbGFzcz0iY2hlY2siPjxwYXRoIGZpbGw9ImN1cnJlbnRDb2xvciIgZD0iTTkgMTYuMTcgNS41MyAxMi43YS45OTYuOTk2IDAgMSAwLTEuNDEgMS40MWw0LjE4IDQuMThjLjM5LjM5IDEuMDIuMzkgMS40MSAwTDIwLjI5IDcuNzFhLjk5Ni45OTYgMCAxIDAtMS40MS0xLjQxTDkgMTYuMTdaIiBjbGFzcz0idmVjdG9yIi8+PC9nPjwvc3ZnPg==";